import { SANCTION_TYPES } from "./sanctionConstants";

const SanctionTypeSelector = ({
  sanctionTypes,
  availableSanctionTypes,
  selectedType,
  onTypeChange,
}) => {
  return (
    <div className="mb-4 p-3 rounded" style={{ background: "#f8f9fa" }}>
      <label className="font-weight-bold mb-2" style={{ fontSize: 14 }}>
        Type de sanction <span className="text-danger">*</span>
      </label>
      <div className="d-flex flex-wrap" style={{ gap: 10 }}>
        {Object.values(sanctionTypes).map((sanctionType) => {
          const typeConfig = availableSanctionTypes?.find(
            (t) => t.id === sanctionType,
          );
          const hasError = typeConfig?.erreur;
          return (
            <div key={sanctionType} className="flex-grow-1">
              <button
                type="button"
                className={`btn border w-100 ${
                  selectedType === sanctionType ? "btn-primary" : "btn-default"
                }`}
                style={{
                  opacity: hasError ? 0.6 : 1,
                  cursor: hasError ? "not-allowed" : "pointer",
                }}
                onClick={() => {
                  if (!hasError && selectedType !== sanctionType) {
                    onTypeChange(sanctionType);
                  }
                }}
              >
                {sanctionType === SANCTION_TYPES.SUSPENSION
                  ? "Suspension"
                  : "Suppression"}
              </button>
              {hasError && (
                <div
                  className="alert alert-warning mt-2 mb-0"
                  style={{ fontSize: 13, padding: "8px 12px" }}
                >
                  <small>⚠️ {typeConfig.erreur}</small>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SanctionTypeSelector;
